import { render } from "./SubscriptionSuccess.vue?vue&type=template&id=bbb53d5a&scoped=true"
import script from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuccess.vue?vue&type=script&lang=js"

import "./SubscriptionSuccess.vue?vue&type=style&index=0&id=bbb53d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb53d5a"]])

export default __exports__